<template>
  <v-app>
    <header class="pl-16 v-app-bar" style="background: #fff;">
      <div class="v-toolbar__content" style="height: 56px;">
        <v-btn class="back white" icon large>
            <router-link :to="{ name: this.modo === 'salida' ? 'Salidas' : 'Entradas'}">
              <v-icon class="icon atras"></v-icon>
            </router-link>
          </v-btn>
          <v-row>
            <div elevation="0" class="pl-0 header-icon">
              <v-icon :class="['icon', isSalida ? 'caja' : 'caja-out']"></v-icon>
            </div>
          </v-row>
        <!-- <Header /> -->
          <div class="d-flex align-center mr-auto pr-4 pl-14">
            <v-text-field
              label="Buscar albarán"
              text
              clearable
              hide-details
              v-model="codigoAlbaran" 
              class="pt-0 ml-7"
              >
            </v-text-field>
            <v-icon class="icon search" icon large> </v-icon>
          </div>
        </div>
    </header>
    <Menu/>
     
    <v-main class="order margin-top">
      <div v-if="cargando" class="mt-15 text-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>

      <div class="mt-3" subheader two-line v-else>
        <v-list class="py-0" v-for="albaran in albaranesFiltrado" :key="getId(albaran)" >
        <v-divider v-if="albaran.tipo !== 'PICKUP_POINT'"></v-divider>
        <!-- TODO: momentaneamente quitamos los goldservice PDTE de cambio de iñigo para tenerlo -->
          <v-list-item v-if="albaran.tipo !== 'PICKUP_POINT'" @click="verDetalle(albaran)">
            <v-list-item-avatar>
              <v-icon class="accent" dark>
                mdi-file-document-outline
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="v-list-item__title primary--text" >
                <span class="font-weight-bold" v-text="getCodigo(albaran)"></span> <span class="font-weight-bold" v-text="albaran.origen_cod + '-' + albaran.origen_nombre"></span> 
              </v-list-item-title>
              <v-list-item-subtitle class="accent--text ">  <span class=" font-weight-bold" v-text="getReferencia(albaran)"></span></v-list-item-subtitle>
              <p class="font-weight-light mb-0 pa-0 caption d-flex text-truncate">{{ getFecha(albaran) }}</p>
            </v-list-item-content>
            <!--<v-list-item-action>
              <v-btn icon>
                <v-icon :color="albaran.color" v-text="albaran.icon"></v-icon>
              </v-btn>
            </v-list-item-action>-->
          </v-list-item>
        </v-list>
      </div>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Menu from '../../components/Menu.vue';

import { AlbaranApiService } from '../../api/AlbaranApiService';
const albaranApiService = new AlbaranApiService();

export default {
  name: 'Albaranes',
  components: {
    Menu
  },
  data() {
    return {
      cargando: false,
      codOdt: '',
      modo: 'entrada',
      opUid: null,
      albaranes: [],
      albaranesFiltrado: [],
      // files: [
      //   { icon: 'mdi-information', color: 'grey lighten-1', subtitle: '3/03/2014', title: 'SSCC3', number: '0028434690000', bold: '255732' },
      //   { icon: 'mdi-check-circle', color: 'success', subtitle: '3/03/2014', title: 'SSCC4', number: '0028434690000', bold: '255732' },
      //   { icon: 'mdi-check-circle', color: 'success', subtitle: '3/03/2014', title: 'SSCC5', number: '0028434690000', bold: '255732' },
      // ],
      codigoAlbaran: ''
    };
  },
  computed: {
    cambiotienda() {
      return this.$store.getters.getOpuid;
    },
    isSalida() {
      return this.modo === 'salida';
    },
  },
  watch: {
    cambiotienda(value) {
      this.opUid = value;
      this.init();
    },
    codigoAlbaran(value) {
      this.filtarAlbaran(value)
    }
  },
  beforeCreate () {
    this.$root.$emit('verificarCertificado', location.href)
  },
  created() {
    this.opUid = this.$store.getters.getOpuid
    // determine modo from route query (forwarded from Salidas)
    this.modo = this.$route.query.modo
    this.init()
  },
  methods: {
    init() {
      this.albaranes = this.getAlbaranesByOpuid()
    },
    getAlbaranesByOpuid() {
      this.cargando = true
      albaranApiService.getAlbaranesCab(this.opUid, this.modo)
        .then((data) => {
          // console.log(data)
          this.cargando = false
          if (data.data) {
            this.albaranes = data.data
            this.albaranesFiltrado = this.albaranes
          }
          
        })
        .catch((error) => {
          this.cargando = false
          this.$root.$emit('mostrarAlerta', 'Error al obtener albaranes', 'error')
          console.log('albaranApiService - getAlbaranesCab ' + error)
        });
    },
    filtarAlbaran() {
      if (this.codigoAlbaran && this.codigoAlbaran.length > 0) {
        this.albaranesFiltrado = this.albaranes.filter(item =>{
          return (this.getCodigo(item).indexOf(this.codigoAlbaran) >= 0 || 
                  item.origen_cod.indexOf(this.codigoAlbaran) === 0 || 
                  this.getReferencia(item).toUpperCase().indexOf(this.codigoAlbaran.toUpperCase()) >= 0)
        })
      } else {
        this.albaranesFiltrado = this.albaranes
      }
    },
    getId(albaran) {
      return albaran[this.modo === 'salida' ? 'odt_id' : 'albaran_id']
    },
    getUid(albaran) {
      return albaran[this.modo === 'salida' ? 'odt_uid' : 'albaran_uid']
    },
    getCodigo(albaran) {
      return albaran[this.modo === 'salida' ? 'odt_codigo' : 'albaran_codigo']
    },
    getReferencia(albaran) {
      return albaran[this.modo === 'salida' ? 'odt_referencia' : 'albaran_referencia']
    },
    getFecha(albaran) {
      return albaran[this.modo === 'salida' ? 'odt_fecha' : 'albaran_fecha']
    },
    verDetalle(albaran) {
      // La funcionalidad de albaran en curso no tiene sentido, si salen de la pantalla se pierden las lecturas, no importa

      // if (this.$store.getters.getAlbaranEnCurso && this.$store.getters.getAlbaranEnCurso !== null) {
      //   if (this.$store.getters.getAlbaranEnCurso.albaran_uid !== albaran.albaran_uid) {
      //     this.$root.$confirm.open('Conexión', 'Ya hay un albaran en curso, se borraran las lecturas ¿Desea continuar?', { color: 'primary' }).then((confirm) => {
      //       if (confirm) {
      //         this.$store.commit('setBultoAlbaranEnCurso', albaran)
      //         this.$router.push({ path: '/AlbaranDetalle/' + albaran.albaran_uid });
      //       }
      //     })
      //   } else {
      //     this.$store.commit('setBultoAlbaranEnCurso', albaran)
      //     this.$router.push({ path: '/AlbaranDetalle/' + albaran.albaran_uid });
      //   }
      // } else {
      //   this.$store.commit('setBultoAlbaranEnCurso', albaran)
      //   this.$router.push({ path: '/AlbaranDetalle/' + albaran.albaran_uid });
      // }
      this.$store.commit('setBultoAlbaranEnCurso', albaran)
      // preserve modo query if present in current route (forward from Salidas)
      const modo = this.$route.query.modo
      this.$router.push({ path: '/AlbaranDetalle/' + this.getUid(albaran), query: { modo } });
    }
  },
};
</script>